import {
  OrderDirection,
  commonMutationTypes,
} from "../../../../../../utils/commonQueryTypes";
import { TableType } from "../../../../customer/companies/queries/types";
import { PageInfo } from "../../../../customer/settings/predefinedList/queries/types";
import { AtsSubsidiary } from "../../../masters/subsidary/queries/types";
import { EmpMaster } from "../../queries/types";

export interface AddUserRightsResult {
  AddUserRights: boolean;
}

export interface UserRights {
  ids: number[];
  tableLevel: TableType;
}

export interface AddUserRightsVar extends commonMutationTypes {
  customerID: number;
  empID: number;
  input: UserRights;
}

export enum UserRightsMasterOrderField {
  EMP_ID = "EMP_ID",
}

export interface UserRightsMasterOrder {
  direction: OrderDirection;
  field: UserRightsMasterOrderField;
}

export interface GetUserRightsVar {
  token?: string;
  customerID: number;
  after: string | null;
  first: number | null;
  orderBy: UserRightsMasterOrder;
  // name: string;
}

export interface UserRightsDetails {
  id: number;
  subsidiaryID: number;
  companyID: number;
  siteID: number;
  junctionID: number;
  user_rights_master_id: number;
  company: {
    id: number;
    name: string;
  };
  siteDetails: {
    name: string;
  };
  junctionDetails: {
    name: string;
  };
  subsidiaryDetails: AtsSubsidiary;
}

export interface UserRightsMaster {
  id: number;
  empID: number;
  defaultTheme: string;
  customerID: number;
  isSysadmin: boolean;
  tableLevel: TableType;
  empDetails: EmpMaster;
  rightsDetails: UserRightsDetails[];
}

export interface UserRightsMasterEdge {
  node: UserRightsMaster;
  cursor: string;
}

export interface UserRightsMasterConnection {
  edges: UserRightsMasterEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface GetUserRightsResult {
  GetUserRights: UserRightsMasterConnection;
}

export enum UserRightsTypes {
  SYSADMIN = "SYSADMIN",
  ADMIN = "ADMIN",
  BASIC = "BASIC",
  VIEW = "VIEW",
}

export interface GetUserRightsByEmpIdResult {
  GetUserRightsByEmpId: UserRightsMaster;
}

export interface GetUserRightsByEmpIdVar {
  token?: string;
  customerID: number;
  empID: number;
}

export interface UpdateUserRightsResult {
  UpdateUserRights: boolean;
}

export interface UpdateUserRightsVar extends commonMutationTypes {
  customerID: number;
  empID: number;
  input: UserRights;
}
